import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const EMPLOYEES_URL = `${API_BASE_URL}/employees/employees/`;
const ROLES_URL = `${API_BASE_URL}/employees/roles/`;

const getHeaders = () => ({
  'Authorization': `Token ${authService.getToken()}`,
  'Content-Type': 'application/json'
});

/**
 * The roles endpoint is paginated like everything else, but its only consumer
 * is a dropdown that wants the rows. Unwrapping here keeps that detail in one
 * place instead of in every caller.
 */
const unwrapRows = (response) => ({
  ...response,
  data: response.data?.results ?? []
});

const employeesService = {
  /**
   * Lists employees. Takes an options object rather than positional arguments,
   * the project-wide convention for list services. Empty filters are omitted so
   * the API never receives a blank value to match on.
   */
  listEmployees: ({
    search = null,
    roleId = null,
    showInactive = false,
    ordering = '-created_at',
    page = 1
  } = {}) => {
    const params = { ordering, page };

    if (search) params.search = search;
    if (roleId) params.role_id = roleId;
    if (showInactive) params.show_inactive = 'true';

    return axios.get(EMPLOYEES_URL, { headers: getHeaders(), params });
  },

  getEmployeeById: (id) => {
    return axios.get(`${EMPLOYEES_URL}${id}/`, { headers: getHeaders() });
  },

  createEmployee: (data) => {
    return axios.post(EMPLOYEES_URL, data, { headers: getHeaders() });
  },

  updateEmployee: (id, data) => {
    return axios.patch(`${EMPLOYEES_URL}${id}/`, data, { headers: getHeaders() });
  },

  /** Flips is_active, so a deactivated employee can be brought back. */
  toggleActive: (id) => {
    return axios.patch(`${EMPLOYEES_URL}${id}/toggle_active/`, {}, {
      headers: getHeaders()
    });
  },

  listRoles: async () => {
    const response = await axios.get(ROLES_URL, { headers: getHeaders() });
    return unwrapRows(response);
  }
};

export default employeesService;
